import script from "./ContentComments.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentComments.vue?vue&type=script&setup=true&lang=js"

import "./ContentComments.vue?vue&type=style&index=0&id=9287075e&lang=scss"

const __exports__ = script;

export default __exports__